import React from "react";

function fmtAgo(iso) {
  if (!iso) return "";
  const t = new Date(iso).getTime();
  if (!t) return "";
  const diffSec = Math.max(0, Math.floor((Date.now() - t) / 1000));
  if (diffSec < 60) return `${diffSec}s ago`;
  const m = Math.floor(diffSec / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  return `${h}h ago`;
}

/**
 * Small pill rendered next to a daily-budget value when it changed within the last hour.
 * Props:
 *   - changedAt: ISO timestamp of last change
 *   - from: previous budget (number)
 *   - to: new budget (number)
 *   - pct: change percentage
 *   - direction: 'increase' | 'decrease'
 *   - currency (default '£')
 */
export default function RecentBudgetBadge({ changedAt, from, to, pct, direction, currency = "£", testid }) {
  if (!changedAt) return null;
  // Hide automatically if older than 1 hour
  const ageMs = Date.now() - new Date(changedAt).getTime();
  if (ageMs > 60 * 60 * 1000) return null;
  const up = direction === "increase";
  const arrow = up ? "▲" : "▼";
  const cls = up
    ? "bg-emerald-50 text-emerald-700 border-emerald-200"
    : "bg-amber-50 text-amber-700 border-amber-200";
  const tooltip = `${currency}${Number(from || 0).toFixed(2)} → ${currency}${Number(to || 0).toFixed(2)} (${up ? "+" : "−"}${Number(pct || 0).toFixed(0)}%) · ${fmtAgo(changedAt)}`;
  return (
    <span
      data-testid={testid}
      title={tooltip}
      className={`inline-flex items-center gap-0.5 px-1 py-0.5 text-[9px] font-mono border ${cls}`}
    >
      <span className="text-[8px] leading-none">{arrow}</span>
      {Math.abs(Number(pct || 0)).toFixed(0)}%
    </span>
  );
}
